import api_config from '../config/api'

export default {
	async getAbout(lang) {
		return api_config.get(`api/about/${lang}`)
	},
}
